import type { TArticle } from '~~/types/local_types';
import useGetUrl from '~/composables/useArticleUrl';

export default function useHistory(article: TArticle) {
  const pageUrl = useGetUrl(article.articleType, article.slug);

  const base = window.location.href.split(window.location.pathname)[0] as string;
  return window.history.replaceState(window.history.state, '', `${base}${pageUrl}`);
}
